const Modal = require('./modal');
const template = require('./alert.tpl').default;

module.exports = DomClass(template, function() {
	var _t = this;

	Modal.call(this);

	this.__dom.closeButton.onclick = function() {
		on(_t, 'close').fire();
		_t.close();
	};

	on(this, 'open').then(function() {
		_t.__dom.closeButton.focus();
	});

	on(this, 'close').then(function() {
		if (_t.parentNode) _t.parentNode.removeChild(_t);
	});

	document.body.appendChild(this);
	this.open();

});
